/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SlotStatus } from './slotStatus';
import type { BoundTaskRef } from './boundTaskRef';
import type { AppointmentSlotRecurrence } from './appointmentSlotRecurrence';
import type { AppointmentSession } from './appointmentSession';
import type { AppointmentSlotVideoMeetingProvider } from './appointmentSlotVideoMeetingProvider';
import type { AppointmentSlotVideoMeetingId } from './appointmentSlotVideoMeetingId';
import type { AppointmentSlotVideoMeetingJoinUrl } from './appointmentSlotVideoMeetingJoinUrl';
import type { AppointmentSlotLivekitRoomName } from './appointmentSlotLivekitRoomName';
import type { AppointmentSlotVideoMeetingModeratorUrl } from './appointmentSlotVideoMeetingModeratorUrl';
import type { AppointmentSlotVideoMeetingPassword } from './appointmentSlotVideoMeetingPassword';
import type { AppointmentSlotVideoMeetingCalendarEventId } from './appointmentSlotVideoMeetingCalendarEventId';
import type { AppointmentSlotMeetingCreatedAt } from './appointmentSlotMeetingCreatedAt';
import type { AppointmentSlotInviteResponseStatus } from './appointmentSlotInviteResponseStatus';
import type { AppointmentSlotInviteResponseAt } from './appointmentSlotInviteResponseAt';
import type { AppointmentSlotCancelledAt } from './appointmentSlotCancelledAt';
import type { AppointmentSlotCancelledBy } from './appointmentSlotCancelledBy';

/**
 * Appointment slot information
 */
export interface AppointmentSlot {
  slotId: string;
  startTime: string;
  endTime: string;
  capacity: number;
  availableSpots: number;
  status: SlotStatus;
  lecturerId: string;
  eventKindId: string;
  /** Resolved info for bound tasks to render module/task names */
  boundTasks?: BoundTaskRef[];
  eventKindLabel: string;
  durationMinutes: number;
  recurrence?: AppointmentSlotRecurrence;
  extraSessions?: AppointmentSession[];
  videoMeetingProvider?: AppointmentSlotVideoMeetingProvider;
  videoMeetingId?: AppointmentSlotVideoMeetingId;
  videoMeetingJoinUrl?: AppointmentSlotVideoMeetingJoinUrl;
  livekitRoomName?: AppointmentSlotLivekitRoomName;
  videoMeetingModeratorUrl?: AppointmentSlotVideoMeetingModeratorUrl;
  videoMeetingPassword?: AppointmentSlotVideoMeetingPassword;
  videoMeetingCalendarEventId?: AppointmentSlotVideoMeetingCalendarEventId;
  meetingCreatedAt?: AppointmentSlotMeetingCreatedAt;
  inviteResponseStatus?: AppointmentSlotInviteResponseStatus;
  inviteResponseAt?: AppointmentSlotInviteResponseAt;
  cancelledAt?: AppointmentSlotCancelledAt;
  cancelledBy?: AppointmentSlotCancelledBy;
}
